import { render, staticRenderFns } from "./info2.vue?vue&type=template&id=e1050382&scoped=true&"
import script from "./info2.vue?vue&type=script&lang=js&"
export * from "./info2.vue?vue&type=script&lang=js&"
import style0 from "./info2.vue?vue&type=style&index=0&id=e1050382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1050382",
  null
  
)

export default component.exports